import styles from "./userresetpassblock.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import PrimaryButton from "../PrimaryButton";
import InputOTP from "../InputOTP";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { UpdateUserPassword } from "../../apis/user";
import { useCookies } from "react-cookie";

export default function UserResetPassBlock() {
  const { t } = useTranslation();
  const [cookie, setCookie] = useCookies(["user_info"])

  const [userPass, setUserPass] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const [OTP, setOTP] = useState("");

  const handleChange = (type, e) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-~])[a-zA-Z0-9!-/:-@[-`{-~]{8,36}$/;
    if (type === "oldPassword") {
      setUserPass({ ...userPass, oldPassword: e.target.value });
      setError((prevError) => ({
        ...prevError,
        oldPassword: e.target.value === "",
      }));
    } else if (type === "newPassword") {
      setUserPass({ ...userPass, newPassword: e.target.value });
      setError((prevError) => ({
        ...prevError,
        newPassword: !passwordRegex.test(e.target.value),
      }));
    } else if (type === "confirmPassword")
      setUserPass({ ...userPass, confirmPassword: e.target.value });
    setError((prevError) => ({
      ...prevError,
      confirmPassword:
        userPass.newPassword !== e.target.value &&
        userPass.newPassword !== "" &&
        type === "confirmPassword",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation for required fields
    if (error.oldPassword || error.newPassword || error.confirmPassword) {
      toast.error(t("invalid_data"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      return;
    }

    toast.promise(new Promise(async (resolve, reject) => {
      const result = await UpdateUserPassword({
        emailOrPhone: cookie["user_info"].email ? cookie["user_info"].email : cookie["user_info"].phone,
        oldPassword: userPass.oldPassword,
        password: userPass.newPassword,
        confirmPassword: userPass.confirmPassword,
        otp: OTP
      })

      if (result.status === 200) resolve(result);
      else reject(result);
    }), {
      pending: {
        render() {
          return "Submitting...";
        },
      },
      success: {
        render({ data }) {
          // API call here
          return t("change_pass_success");
        },
      },
      error: {
        render({ data }) {
          return `An error occurred: ${data.response?.data?.message || data.message
            }`;
        },
      },
    });
  };
  return (
    <div className={styles.userResetPassBlock}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <div className={styles.header}>
        <h3>{t("user_reset_pass")}</h3>
        <span>{t("to_protect_account_please_do_not_share_to_others")}</span>
      </div>
      <form className={styles.userResetPassForm}>
        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="name">
            {t("enter_old_password")}
          </label>
          <TextField
            required
            type="password"
            error={error.oldPassword}
            helperText={error.oldPassword ? t("password_cannot_be_empty") : ""}
            id="oldpassword"
            value={userPass.oldPassword}
            label={t("old_password")}
            onChange={(e) => handleChange("oldPassword", e)}
            variant="outlined"
            size="small"
            sx={{
              width: "60%",
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#e7851a",
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#e7851a",
                },
              },
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="name">
            {t("enter_new_password")}
          </label>
          <TextField
            type="password"
            required
            id="newpassword"
            error={error.newPassword}
            helperText={error.newPassword ? t("validate_password") : ""}
            value={userPass.newPassword}
            label={t("new_password")}
            onChange={(e) => handleChange("newPassword", e)}
            variant="outlined"
            size="small"
            sx={{
              width: "60%",
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#e7851a",
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#e7851a",
                },
              },
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="name">
            {t("enter_confirm_password")}
          </label>
          <TextField
            required
            type="password"
            error={error.confirmPassword}
            helperText={error.confirmPassword ? t("passwords_must_match") : ""}
            id="confirmpassword"
            value={userPass.confirmPassword}
            label={t("enter_confirm_password")}
            onChange={(e) => handleChange("confirmPassword", e)}
            variant="outlined"
            size="small"
            sx={{
              width: "60%",
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "#e7851a",
                },
              },
              "& .MuiInputLabel-root": {
                "&.Mui-focused": {
                  color: "#e7851a",
                },
              },
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label}>{t("enter_otp")}</label>
          <InputOTP OTPValue={OTP} setOTPValue={setOTP} />
        </div>
        <div className={styles.formGroup}>
          <div className={styles.saveButton}>
            <PrimaryButton
              type={"submit"}
              text={t("confirm")}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
